import script from "./CategoriaListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaListView.vue?vue&type=script&setup=true&lang=js"

import "./CategoriaListView.vue?vue&type=style&index=0&id=7018ae21&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7018ae21"]])

export default __exports__